
interface IProps {
    pin: string;
    checkPin?: string;
    isCheckView?: boolean;
}   


const PinIndicator = ({pin, checkPin, isCheckView}: IProps) => {
    return <div className="pin-dots">
         <div className="pin-dots">
                    {[...Array(6)].map((_, index) => (
                        <div 
                            key={index} 
                            className={`pin-dot ${index < (isCheckView ? (checkPin ?? '').length : pin.length) ? 'active' : ''}`}
                        ></div>
                    ))}
                </div>
    </div>
}

export default PinIndicator;